// eslint-disable-next-line no-restricted-imports
import { Record, Set } from '@gonfalon/immutable-shim/immutableShim';

type MemberPermissionGrantsType = {
  resource: string;
  actions?: Set<string>;
  actionSet: string;
};

export class MemberPermissionGrants extends Record<MemberPermissionGrantsType>({
  resource: '',
  actions: Set(),
  actionSet: '',
}) {
  isTeamMaintainer() {
    return this.actionSet === 'maintainTeam';
  }
  parseResource() {
    return this.resource.split('/');
  }
}
